import { Box, Typography } from '@mui/material';
import { useTitle } from 'shared/hooks';
import { UserInfo } from 'shared/types';
import { TableManageCustomerParameters } from './table';

interface ManageCustomerParametersPageProps {
  user: UserInfo;
}

export function ManageCustomerParametersPage({ user }: ManageCustomerParametersPageProps) {
  useTitle('Customer Parameters');
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Typography sx={{ alignSelf: 'center', py: 2 }} variant='h4'>
        Customer Parameter Management
      </Typography>
      <TableManageCustomerParameters user={user} />
    </Box>
  );
}
